import {
  ReferralImpact,
  User,
  UserType,
  getProfileSocialImage,
} from "@ecologi/shared";
import { getClientUrl } from "../../../lib";

export function selectStats(profile: User, referralData?: ReferralImpact) {
  const referralTrees =
    referralData && referralData.trees ? referralData.trees : [];

  const totalReferralTrees = referralTrees.reduce(
    (sum, t) => sum + t.totalTrees,
    0
  );

  const numberOfTrees = profile.totalTrees || totalReferralTrees;
  const numberOfTonnes = profile.totalCarbonTonnes || 0;
  const numberOfTonnesRemoved = profile.totalCarbonRemovedTonnes || 0;
  const numberOfMetersRestored = profile.totalHabitatMetersRestored || 0;

  return {
    numberOfTonnes,
    numberOfTrees,
    totalReferralTrees,
    numberOfTonnesRemoved,
    numberOfMetersRestored,
  };
}

export function selectProfileMeta(
  profile: User,
  referralData?: ReferralImpact
) {
  const { numberOfTonnes, numberOfTrees } = selectStats(profile, referralData);
  const clientUrl = getClientUrl();
  const profileSocialImage = getProfileSocialImage(
    profile.getProfileImage(clientUrl),
    numberOfTrees
  );

  // Set custom social titles and descriptions if needed
  const socialTitle = profile.fullName();
  const socialDescription =
    numberOfTonnes > 0
      ? `View ${
          profile.fullNamePlural
        } Ecologi profile. So far they've helped avoid ${numberOfTonnes.toLocaleString()} tonnes of emissions, and funded the planting of ${numberOfTrees} trees!`
      : `View ${
          profile.fullNamePlural
        } Ecologi profile. So far they've planted ${numberOfTrees.toLocaleString()} trees!`;

  return {
    profileSocialImage,
    socialTitle,
    socialDescription,
  };
}

export const selectFormattedUserType = (user: User | UserType): User => {
  /**
   * The profile will be of type `UserType` when viewing another users profile.
   *
   * If you are viewing your own profile (public or private) then we use the type from the store `User`
   *
   * The following logic converts `UserType` into `User`. The profile page UI is based off the `User` type.
   *
   * `User` is non-serialisable in Next SSR. Which is the main reason why there is two different type definitions.
   */
  const isUserType = (user as any)?.isUserType;
  return isUserType ? (user as User) : new User(user as UserType);
};
